<script>
import MenuGrid from "@components/menu-grid/menu-grid.vue";

export default {
  name: "menu",
  components: {MenuGrid},
  watch: {
    '$route.params.id': function (id) {
      this.fetchData(id)
    }
  },
  data: () =>({
    items:[],
    sections: []
  }),
  mounted() {
    const {id, pathName} = this.$route.params;
    this.fetchData(id)
  },
  methods: {
    async fetchData(id) {
      this.$vs.loading();
      try {
        const {data} = await axios.get(`/api/backoffice/navigation/menu/item/${id}`)
        this.items = data;
        this.sections = data.children
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<template>
  <div>
    <menu-grid :sections="sections"></menu-grid>
  </div>
</template>

<style scoped>

</style>